import styled, { css } from '../../../styles/theme';
import { FilterButtonStyled } from '../FilterButtonStyled';

export const FilterButtonStyledAC = styled(FilterButtonStyled)`
    border: 1px solid ${({ theme }) => theme.colors.grey2};
    color: ${({ theme }) => theme.colors.grey2};

    ${({ active }) =>
        active &&
        css`
            border-color: ${({ theme }) => theme.colors.primary};
            background: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.primary};
        `};

    ${({ disabled }) =>
        disabled &&
        css`
            border-color: ${({ theme }) => theme.colors.primaryDisabled};
            background: ${({ theme }) => theme.colors.primaryDisabled};
            color: ${({ theme }) => theme.colors.grey2};
        `};
`;
